<div class="min-h-screen px-8 py-8">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@profilePageTitle">Profile</h1>

  <div class="w-full rounded-[12px] bg-white p-6 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.5 5.5C3.5 4.17392 4.02678 2.90215 4.96446 1.96447C5.90215 1.02678 7.17391 0.5 8.5 0.5C9.82608 0.5 11.0978 1.02678 12.0355 1.96447C12.9732 2.90215 13.5 4.17392 13.5 5.5C13.5 6.82608 12.9732 8.09785 12.0355 9.03554C11.0978 9.97322 9.82608 10.5 8.5 10.5C7.17391 10.5 5.90215 9.97322 4.96446 9.03554C4.02678 8.09785 3.5 6.82608 3.5 5.5ZM0 17.5C0 16.1739 0.526784 14.9022 1.46447 13.9645C2.40215 13.0268 3.67392 12.5 5 12.5H12C12.6566 12.5 13.3068 12.6293 13.9134 12.8806C14.52 13.1319 15.0712 13.5002 15.5355 13.9645C15.9998 14.4288 16.3681 14.98 16.6194 15.5866C16.8707 16.1932 17 16.8434 17 17.5V19.5H0V17.5Z"
            fill="black" />
        </svg>
        <span class="text-text-heading text-[18px] font-[600]" i18n="@@profileCardTitle">Profile Information</span>
      </div>

      <div class="relative" (click)="$event.stopPropagation()">
        <button
          (click)="toggleMenu()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-[8px] border-none transition-colors duration-150"
          [ngClass]="menuOpen() ? 'bg-gray-100' : 'bg-transparent hover:bg-gray-100'"
          aria-label="Profile actions"
          i18n-aria-label="@@profileMenuAriaLabel">
          <svg width="4" height="18" viewBox="0 0 4 18" fill="none">
            <circle class="fill-text-body" cx="2" cy="2" r="2" />
            <circle class="fill-text-body" cx="2" cy="9" r="2" />
            <circle class="fill-text-body" cx="2" cy="16" r="2" />
          </svg>
        </button>

        @if (menuOpen()) {
          <div
            class="absolute top-[calc(100%+4px)] z-50 min-w-[220px] rounded-[12px] bg-white px-1.5 py-1.5 shadow-[0px_4px_24px_rgba(0,0,0,0.10)]"
            [attr.dir]="isRtl ? 'rtl' : 'ltr'"
            [ngClass]="isRtl ? 'left-0' : 'right-0'">
            <button
              (click)="onUpdateProfile()"
              class="text-text-menu hover-bg-hover-surface flex w-full cursor-pointer items-center gap-3 rounded-[8px] border-none bg-transparent px-3 py-[10px] text-[14px] transition-colors duration-100">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="text-text-subdued shrink-0">
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M3 22C3 17.5817 7.02944 14 12 14"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M17.5 19.5L15 22L14 21"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M22 18.5C22 20.433 20.433 22 18.5 22C16.567 22 15 20.433 15 18.5C15 16.567 16.567 15 18.5 15C20.433 15 22 16.567 22 18.5Z"
                  stroke="currentColor"
                  stroke-width="1.8" />
              </svg>
              <span i18n="@@profileMenuUpdateProfile">Update Profile</span>
            </button>

            <button
              (click)="onChangePassword()"
              class="text-text-menu hover-bg-hover-surface flex w-full cursor-pointer items-center gap-3 rounded-[8px] border-none bg-transparent px-3 py-[10px] text-[14px] transition-colors duration-100">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="text-text-subdued shrink-0">
                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="1.8" />
                <path
                  d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round" />
                <circle cx="12" cy="16" r="1.5" fill="currentColor" />
              </svg>
              <span i18n="@@profileMenuChangePassword">Change Password</span>
            </button>

            <button
              (click)="onChangeLanguage()"
              class="text-text-menu hover-bg-hover-surface flex w-full cursor-pointer items-center gap-3 rounded-[8px] border-none bg-transparent px-3 py-[10px] text-[14px] transition-colors duration-100">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="text-text-subdued shrink-0">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
                <path
                  d="M12 3C12 3 9 7 9 12C9 17 12 21 12 21"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round" />
                <path
                  d="M12 3C12 3 15 7 15 12C15 17 12 21 12 21"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round" />
                <path d="M3 12H21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
              <span i18n="@@profileMenuChangeLanguage">Change Language</span>
            </button>

            <div class="bg-border-subtle mx-1 my-1.5 h-px"></div>

            <button
              (click)="onDeactivateAccount()"
              class="text-warning-text hover-bg-warning-surface flex w-full cursor-pointer items-center gap-3 rounded-[8px] border-none bg-transparent px-3 py-[10px] text-[14px] transition-colors duration-100">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="shrink-0">
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M3 22C3 17.5817 7.02944 14 12 14C14.0854 14 16.0235 14.6168 17.6395 15.6881"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round" />
                <path d="M16 19H22" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
              <span i18n="@@profileMenuDeactivateAccount">Deactivate Account</span>
            </button>

            <button
              (click)="onDeleteAccount()"
              class="text-danger-text hover-bg-danger-surface flex w-full cursor-pointer items-center gap-3 rounded-[8px] border-none bg-transparent px-3 py-[10px] text-[14px] transition-colors duration-100">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="shrink-0">
                <path
                  d="M3 6H5H21"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span i18n="@@profileMenuDeleteAccount">Delete Account</span>
            </button>
          </div>
        }
      </div>
    </div>

    <div class="bg-border-subtle my-4 h-[2px]"></div>

    <div class="text-[15px]" dir="ltr">
      @if (loading()) {
        <div class="flex justify-center py-8">
          <app-loading />
        </div>
      } @else {
        <div class="mb-5 flex">
          <div class="flex w-1/2 flex-col gap-1" [style.text-align]="isRtl ? 'right' : 'left'">
            <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldMobile">Mobile</p>
            <p class="text-text-heading">{{ profile()?.mobileNumber || "—" }}</p>
          </div>
          <div class="flex w-1/2 flex-col gap-1" [style.text-align]="isRtl ? 'right' : 'left'">
            <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldFullName">Full Name</p>
            <p class="text-text-heading">{{ profile()?.firstName }} {{ profile()?.lastName }}</p>
          </div>
        </div>

        <div class="mb-5 flex">
          <div class="flex w-1/2 flex-col gap-1" [style.text-align]="isRtl ? 'right' : 'left'">
            <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldGender">Gender</p>
            <p class="text-text-heading">
              @if (profile()?.gender === "M") {
                <span i18n="@@profileGenderMale">Male</span>
              } @else {
                <span i18n="@@profileGenderFemale">Female</span>
              }
            </p>
          </div>
          <div class="flex w-1/2 flex-col gap-1" [style.text-align]="isRtl ? 'right' : 'left'">
            <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldEmail">Email Address</p>
            <p class="text-text-heading">{{ profile()?.email || "—" }}</p>
          </div>
        </div>

        <div class="flex">
          <div class="flex w-1/2 flex-col gap-1" [style.text-align]="isRtl ? 'right' : 'left'">
            <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldBirthDate">Birth Date</p>
            <p class="text-text-heading">
              {{ profile()?.birthDate ? (profile()!.birthDate | date: "dd/MM/yyyy") : "—" }}
            </p>
          </div>
          <div class="flex w-1/2 flex-col gap-5" [style.text-align]="isRtl ? 'right' : 'left'">
            <div class="flex flex-col gap-1">
              <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldDefaultLanguage">Default Language</p>
              <p class="text-text-heading">
                @if (profile()?.defaultLanguage === "EN") {
                  <span i18n="@@profileLanguageEnglish">English</span>
                } @else {
                  <span i18n="@@profileLanguageArabic">Arabic</span>
                }
              </p>
            </div>
            <div class="flex flex-col gap-1">
              <p class="font-[500] text-[rgb(106,106,106)]" i18n="@@profileFieldMemberSince">Member Since</p>
              <p class="text-text-heading">
                {{ profile()?.createdOn ? (profile()!.createdOn | date) : "—" }}
              </p>
            </div>
          </div>
        </div>

        @if (errorMessage()) {
          <div class="mt-3 rounded-[8px] bg-red-50 px-3 py-2 text-[13px] text-red-600">{{ errorMessage() }}</div>
        }
      }
    </div>
  </div>
</div>
